import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {delay, finalize, map} from 'rxjs/operators';

import {HISTORY_KEY_VIEW_VIDEO, SearchParam} from '../../defines/client.const';
import {CONTENT_TYPE_JSON_UTF8, VIDEO_IN_API_URL} from '../../defines/protocol';
import {Video} from '../../models/video.model';
import {SearchHistory} from '../../models/history.model';
import {VideoLoader} from '../../interfaces/VideoLoader';
import {ApiService} from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class VideoHistoryService implements VideoLoader {
  private history: SearchHistory;

  private load$: Observable<Array<Video>> | null = null;
  public IsLoading(): boolean {
    return this.load$ !== null;
  }

  constructor(
    private api: ApiService,
  ) {
    this.history = new SearchHistory({name: HISTORY_KEY_VIEW_VIDEO});
  }

  public addHistory(no: number): void {
    if (this.history === null) {
      console.error('VideoHistoryService::addHistory() history is null');
    }
    else {
      this.history.addItem(String(no));
    }
  }

  public GetList(param?: SearchParam): Observable<Array<Video>> {
    console.log('VideoHistoryService::GetList()', param);

    if (this.load$) {
      return this.load$;
    }

    if (this.history === null) {
      throw new Error('VideoHistoryService::GetList() history is null');
    }

    if (this.history.empty()) {
      return new Observable<Array<Video>>(observer => {
        observer.next([]);
        observer.complete();
      }).pipe(delay(0));
    }

    const url = VIDEO_IN_API_URL;
    return this.load$ = this.api.Post(url, {list: this.history.list}, null, CONTENT_TYPE_JSON_UTF8).pipe(
      finalize(() => {
        this.load$ = null;
      }),
      map((data: []) => {
        console.log('VideoHistoryService::GetList()', data);
        const result = new Array<Video>();
        data.forEach(value => result.push(new Video(value)));

        if (result.length !== this.history.size) {
          console.error('VideoHistoryService::GetList() invalid received list size', result, this.history.list);
        }

        return result;
      }),
      // catchError((err, caught: Observable<Array<Video>>) => {
      //   console.error('VideoHistoryService::GetList()', param, err);
      //   throwError(err);
      //   return caught;
      // })
    );
  }
}
